<script setup lang="ts">
import { PropType, ref, watch } from 'vue';
import draggable from 'vuedraggable';

const props = defineProps({
  items: {
    type: Array as PropType<{ id: number; title?: string; text?: string }[]>,
    required: true,
  },
  order: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
  showId: {
    type: Boolean,
    default: () => false,
  },
});

const emit = defineEmits(['change']);

const drag = ref<boolean>(false);
const items = ref<{ id: number; title?: string; text?: string }[]>(
  [...props.items].sort((a, b) =>
    props.order.length
      ? props.order.indexOf(a.id) - props.order.indexOf(b.id)
      : 0,
  ),
);

const dragEnd = () => {
  drag.value = false;

  const sortingOrder = items.value.map((i) => i.id);

  emit('change', sortingOrder);
};

watch(
  () => props.items,
  () => {
    items.value = [...props.items].sort((a, b) =>
      props.order.length
        ? props.order.indexOf(a.id) - props.order.indexOf(b.id)
        : 0,
    );
  },
);
</script>
<template>
  <div class="sort-items">
    <draggable v-model="items" @start="drag = true" @end="dragEnd">
      <template v-slot:item="{ index, element }">
        <div class="draggable">
          <div class="index">{{ index + 1 }}.</div>
          <div class="label">
            {{ element.title || element.text }}
          </div>
          <div v-if="showId" class="id">(ID {{ element.id }})</div>
        </div>
      </template>
    </draggable>
  </div>
</template>
<style scoped>
.sort-items {
  margin: 1em 0;
}
.draggable {
  border: solid 1px gray;
  border-top-color: lightgray;
  border-left-color: lightgray;
  border-radius: 8px;
  padding: 4px 16px;
  margin-bottom: 0.2em;
  cursor: grab;
  display: flex;
  flex-direction: row;
  position: relative;
}

.index {
  width: 16px;
  margin-right: 8px;
  text-align: right;
  font-weight: bold;
}

.label {
  color: rgb(69, 69, 69);
}

.id {
  position: absolute;
  top: 9px;
  right: 16px;
  font-size: 0.6em;
}
</style>
